// 高清韩国漫画 - 网站内容数据（品牌信息、排行榜、常见问题、口碑等）

export const siteInfo = {
  brand: "高清韩国漫画",
  brandEn: "Manhwa HQ",
  slogan: "高清画质 · 每日更新 · 全题材一网打尽",
  description:
    "高清韩国漫画是专注于韩国漫画在线阅读的资讯与导航平台。恋爱、奇幻、校园、悬疑等题材分类齐全，完结排行榜助你快速挑选，每日更新热门作品，无论你偏爱哪种类型，都能轻松找到心仪之作。",
  email: "hello@manhwahq.cn",
  tags: ["高清韩国漫画", "恋爱", "奇幻", "校园", "悬疑", "完结", "排行榜"],
};

export interface RankItem {
  rank: number;
  title: string;
  genre: string;
  chapters: number;
  rating: number;
  likes: number;
  status: string;
  change: string;
}

export const rankList: RankItem[] = [
  { rank: 1, title: "迟来的告白", genre: "恋爱", chapters: 156, rating: 9.7, likes: 95800, status: "完结", change: "up" },
  { rank: 2, title: "心动信号", genre: "恋爱", chapters: 138, rating: 9.6, likes: 86200, status: "连载", change: "up" },
  { rank: 3, title: "无声证词", genre: "悬疑", chapters: 128, rating: 9.6, likes: 88300, status: "完结", change: "same" },
  { rank: 4, title: "樱花入学式", genre: "校园", chapters: 168, rating: 9.5, likes: 90400, status: "完结", change: "down" },
  { rank: 5, title: "迷城疑云", genre: "悬疑", chapters: 64, rating: 9.5, likes: 78200, status: "连载", change: "up" },
  { rank: 6, title: "月下契约", genre: "奇幻", chapters: 96, rating: 9.4, likes: 71500, status: "连载", change: "up" },
  { rank: 7, title: "魔法书店", genre: "奇幻", chapters: 79, rating: 9.4, likes: 66900, status: "连载", change: "down" },
  { rank: 8, title: "雪夜谜案", genre: "悬疑", chapters: 58, rating: 9.4, likes: 73100, status: "完结", change: "same" },
  { rank: 9, title: "契约婚姻", genre: "恋爱", chapters: 110, rating: 9.3, likes: 69100, status: "连载", change: "up" },
  { rank: 10, title: "幻境迷宫", genre: "奇幻", chapters: 142, rating: 9.3, likes: 81700, status: "完结", change: "down" },
];

export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: "高清韩国漫画的更新频率是怎样的？",
    answer:
      "平台每日更新热门作品，漫画分类覆盖恋爱、奇幻、校园、悬疑等题材。你可以在首页的「每日更新」板块查看当天最新上架与更新的作品，同时支持按题材筛选，方便第一时间追更心仪之作。",
  },
  {
    question: "如何快速找到已经完结的漫画？",
    answer:
      "在「完结排行榜」板块，我们集中整理了已完结的高分作品，并按照评分、热度与完结时间排序。你还可以通过顶部导航的分类入口，切换到「完结」筛选，快速挑选无需等待更新、可以一口气读完的故事。",
  },
  {
    question: "网站的题材分类具体有哪些？",
    answer:
      "网站主要涵盖恋爱、奇幻、校园、悬疑四大题材，此外还有日常、热血、穿越、推理等细分标签。每个分类页都配有精选推荐、人气排行与最新更新，帮助你根据当下心情快速找到合适的作品。",
  },
  {
    question: "是否需要注册账号才能浏览内容？",
    answer:
      "网站的核心浏览、分类检索与排行榜功能均免费开放，无需注册即可使用。未来如需收藏作品、记录阅读进度或参与社区讨论，我们建议注册账号以便同步你的追更列表。",
  },
  {
    question: "高分排行榜的评分依据是什么？",
    answer:
      "评分综合了读者投票、阅读完成度、收藏数与社区口碑等多个维度，并持续动态更新。排行榜仅用于辅助选择，建议你结合题材偏好与简介，找到真正契合自己口味的作品。",
  },
  {
    question: "如果在网站遇到问题，如何联系你们？",
    answer:
      "你可以通过页面底部的「联系我们」表单提交问题或建议，我们会在收到反馈后尽快处理。也欢迎通过邮件 hello@manhwahq.cn 与我们沟通作品推荐、版权合作等事宜。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  avatar: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "阿橙",
    role: "恋爱番爱好者",
    avatar: "https://readdy.ai/api/search-image?query=flat%20cartoon%20avatar%20portrait%20of%20a%20cheerful%20young%20asian%20girl%20with%20orange%20hair%2C%20warm%20coral%20background%2C%20clean%20webtoon%20style%2C%20friendly%20smile&width=200&height=200&seq=avatar-01&orientation=squarish",
    text: "在这里找到了好多超喜欢的恋爱漫画，分类清晰不用大海捞针，完结排行榜真的救我这种不爱追连载的人！",
  },
  {
    name: "夜航星",
    role: "奇幻控",
    avatar: "https://readdy.ai/api/search-image?query=flat%20cartoon%20avatar%20portrait%20of%20a%20young%20asian%20man%20with%20glasses%20and%20dark%20hair%2C%20teal%20green%20background%2C%20clean%20webtoon%20style%2C%20calm%20expression&width=200&height=200&seq=avatar-02&orientation=squarish",
    text: "每天更新都很快，奇幻题材的推荐很对我的口味，画质也清晰，追更体验流畅，已经安利给好几个朋友了。",
  },
  {
    name: "小葵",
    role: "校园番回忆杀",
    avatar: "https://readdy.ai/api/search-image?query=flat%20cartoon%20avatar%20portrait%20of%20a%20gentle%20asian%20girl%20with%20short%20black%20hair%20and%20blush%2C%20amber%20yellow%20background%2C%20clean%20webtoon%20style%2C%20soft%20smile&width=200&height=200&seq=avatar-03&orientation=squarish",
    text: "校园题材收藏了很多，看完又哭又笑，是真的会想起自己青春期的作品。排行榜靠谱，几乎没有踩雷！",
  },
];

export interface StatItem {
  value: string;
  label: string;
}

export const stats: StatItem[] = [
  { value: "3,600+", label: "漫画作品" },
  { value: "1,200+", label: "恋爱题材" },
  { value: "860+", label: "完结佳作" },
  { value: "每日", label: "持续更新" },
];